import { BusinessInfo } from '../../../../types';
import { mapResponseToBusinessInfo } from './business-info-mapper';
import { Api } from '../../../index';

export const getBusinessInfo = async (api: Api): Promise<BusinessInfo> => {
  const businessInfo = await api.getBusinessInfo();

  return mapResponseToBusinessInfo(businessInfo);
};
